// extracted by mini-css-extract-plugin
module.exports = {"section":"Gallery_section__i8vwj","nextSection":"Gallery_nextSection___jU4f","titleSection":"Gallery_titleSection__T7mNl","image":"Gallery_image__hYdhw"};